import { ArrowUpRight, Rss } from 'lucide-react'

import { DiscordIcon } from '@/site/ui'

import { DISCORD, FEED, SITE, useCity, usePage } from './api'
import { EventPage, HistoryPage, HomePage, NotFoundPage } from './Pages'
import { useRoute } from './router'
import { Link } from './ui'

function Header({ name }: { name: string }) {
  return (
    <header className="flex items-center justify-between gap-4 py-6 sm:py-8">
      <Link to="/" className="flex items-center gap-3" aria-label={`${name}, stato dei servizi`}>
        <img
          src="/brand/unity-lockup.png"
          alt=""
          width={858}
          height={521}
          className="h-9 w-auto select-none"
          draggable={false}
        />
        <span className="h-6 w-px bg-white/15" aria-hidden />
        <span className="font-display text-fog text-[13px] font-medium tracking-[0.02em]">
          Stato dei servizi
        </span>
      </Link>
      <nav className="flex items-center gap-2" aria-label="Collegamenti">
        <a
          href={SITE}
          className="text-mist hidden items-center gap-1 rounded-full px-3 py-1.5 text-[13px] font-medium hover:bg-white/5 hover:text-white sm:inline-flex"
        >
          unityrp.it
          <ArrowUpRight className="size-3.5" aria-hidden />
        </a>
        <a
          href={DISCORD}
          className="inline-flex items-center gap-2 rounded-full bg-[#5865f2] px-3.5 py-1.5 text-[13px] font-semibold text-white transition-colors hover:bg-[#4752c4]"
        >
          <DiscordIcon className="size-4" />
          Discord
        </a>
      </nav>
    </header>
  )
}

function Footer({ name }: { name: string }) {
  return (
    <footer className="text-mist mt-16 flex flex-col gap-4 border-t border-white/[0.06] py-8 text-[13px] sm:flex-row sm:items-center sm:justify-between">
      <p>
        Gli aggiornamenti arrivano anche sul{' '}
        <a href={DISCORD} className="text-glow hover:text-white">
          Discord
        </a>{' '}
        e nel{' '}
        <a href={FEED} className="text-glow inline-flex items-center gap-1 hover:text-white">
          <Rss className="size-3.5" aria-hidden />
          feed Atom
        </a>
        .
      </p>
      <p>
        © {new Date().getFullYear()} {name} ·{' '}
        <a href={SITE} className="hover:text-white">
          unityrp.it
        </a>
      </p>
    </footer>
  )
}

/**
 * status.unityrp.it: how the city and the services around it are doing. A page of its
 * own, built apart from the console and the community site — see docs/STATUS_PAGE.md.
 */
export function StatusApp() {
  const route = useRoute()
  const { data: page, failed } = usePage()
  const { data: city } = useCity()
  const name = page?.name ?? 'Unity RP'

  return (
    <div className="sky min-h-dvh">
      <div className="mx-auto w-full max-w-[860px] px-4 sm:px-6">
        <Header name={name} />
        {page?.description && route.name === 'home' && (
          <p className="text-mist -mt-2 mb-6 text-[14px]">{page.description}</p>
        )}
        <main>
          {route.name === 'home' && <HomePage page={page} city={city} failed={failed} />}
          {route.name === 'event' && <EventPage key={route.id} id={route.id} />}
          {route.name === 'history' && <HistoryPage />}
          {route.name === 'missing' && <NotFoundPage />}
        </main>
        <Footer name={name} />
      </div>
    </div>
  )
}
